import Swiper from 'swiper' // Import the Swiper library
import SwiperModule from '../lib/swiper-module'

class LargeFormatReviews extends SwiperModule {
  initSwiper() {
    const swiper = new Swiper(this, {
      modules: this.swiperModules,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: `#${this.id} .custom-swiper-button-next`,
        prevEl: `#${this.id} .custom-swiper-button-prev`,
      },
    })

    this.swiper = swiper
    window[`swiper_${this.id}`] = swiper
    this.setupAccessibility(swiper)
  }
}

// Define the custom element 'large-format-reviews'
window.customElements.define('large-format-reviews', LargeFormatReviews)
